// extracted by mini-css-extract-plugin
export default {"productDescription":"hba-z","featuredDescription":"iba-z","description":"jba-z","more":"kba-z","descriptionSku":"lba-z"};